var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLockIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17 9.761V5A5 5 0 107 5v4.761A7.98 7.98 0 004 16a8 8 0 0016 0 7.98 7.98 0 00-3-6.239zM9 5c0-1.654 1.346-3 3-3s3 1.346 3 3v3.587a7.96 7.96 0 00-6 0V5zm3 17c-3.309 0-6-2.691-6-6s2.691-6 6-6 6 2.691 6 6-2.691 6-6 6zm2-6a2 2 0 11-4.001-.001A2 2 0 0114 16z"
  })));
}

export default SvgLockIcon;